export default __webpack_public_path__ + "static/media/season_summer.a0d7444f.webp";